export const PROMO_HIDDEN_COOKIE_VALUE = 'true'
